import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import request from '../../../helpers/request';
import actions from '../store/actions/actions';
import { message } from 'antd';

export const key = (serviceCompanyId) => ['filesDebts', serviceCompanyId];

const getFiles = async (serviceCompanyId, dispatch) => {
  try {
    const res = await request.get(
      `/Receivable/worker_files`,
      { serviceCompanyId },
      'Не получилось загрузить список файлов'
    );

    return res;
  } catch (error) {
    console.error(error);
    message.error('Не получилось загрузить список файлов');
    dispatch({ type: actions.FILE_LIST_LOADED, payload: [] });
    throw error;
  }
};

const useFilesQuery = (options) => {
  const currentCompany = useSelector(
    (store) => store.debtsStore.currentCompany
  );

  const dispatch = useDispatch();

  const serviceCompanyId = currentCompany?.id;

  return useQuery(
    key(serviceCompanyId),
    () => getFiles(serviceCompanyId, dispatch),
    {
      enabled: Boolean(serviceCompanyId),
      staleTime: Infinity,
      ...options,
    }
  );
};

export default useFilesQuery;
